import React, { createContext, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const GlobalSuccessContext = createContext();

export const GlobalSuccessProvider = ({ children }) => {
  const [successMessage, setSuccessMessage] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  const showSuccessModal = (message) => {
    setSuccessMessage(message);
    setShowSuccess(true);
  };

  const hideSuccessModal = () => {
    setSuccessMessage('');
    setShowSuccess(false);
  };

  return (
    <GlobalSuccessContext.Provider value={{ showSuccessModal, hideSuccessModal }}>
      {children}
      {showSuccess && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#e2520f', color: 'white' }}>
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={hideSuccessModal}
                  aria-label="Close"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    cursor: 'pointer',
                  }}
                >
                  <i className="bi bi-check-circle-fill" style={{ fontSize: '1.5rem', color: 'white' }}></i>
                </button>
              </div>
              <div className="modal-body">
                <p>{successMessage}</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={hideSuccessModal}
                  style={{ backgroundColor: '#e2520f', color: 'white', borderColor: '#CC6843' }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </GlobalSuccessContext.Provider>
  );
};

export const useGlobalSuccess = () => useContext(GlobalSuccessContext);
